import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TrialPreLoadingService {

  public trialPreLoaderStatus = new BehaviorSubject<boolean>(false);
  public upsellLoaderStatus = this.trialPreLoaderStatus.asObservable();

  public setProTrialPreLoader(status): void {
    this.trialPreLoaderStatus.next(status);
  }
}
